import { render, staticRenderFns } from "./psp-request-info.vue?vue&type=template&id=ccf00ce6"
import script from "./psp-request-info.vue?vue&type=script&lang=js"
export * from "./psp-request-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports